import { inject, signal } from "@angular/core";
import { ResolveFn } from "@angular/router";
import { catchError, forkJoin, of } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { environment } from "../../../../environments/environment";
import { IsideFlash } from "../../../models/iside-flash";
import { AlertMessageService } from "../alert-msg/message.service";

export const flashcardsDetailsResolver: ResolveFn<any> = (route, state) => {
  const sub_slug = signal<string>(route.paramMap.get("sub") ?? "");
  const subTopic_slug = signal<string>(route.paramMap.get("subTopic") ?? "");
  const cur_slug = signal<string>(route.queryParamMap.get("cur_slug") ?? "");
  const _alertMessageService = inject(AlertMessageService);
  const _httpClient = inject(HttpClient);
  const baseUrl = environment.apiUrl;
  const page = signal(1);

  return forkJoin({
    sidebar: _httpClient
      .get<IsideFlash>(`${baseUrl}api/website/subjects/${sub_slug()}/flashcards/sidebar?curriclum_slug=${cur_slug()}`)
      .pipe(
        catchError((err) => {
          _alertMessageService.addMsg(err?.error?.msg || "Error loading Sub Topics data");
          return of(undefined);
        }),
      ),
    // subTopics :_httpClient.get<IflashContent>(
    //   `${environment.apiUrl}api/website/sub-topics/${subTopic_slug()}/flashcards?curriclum_slug=${cur_slug()}&page=${page()}`
    // )
  });
};
